import { render } from "./DashMyTeam.vue?vue&type=template&id=4b04fa45&scoped=true"
import script from "./DashMyTeam.vue?vue&type=script&lang=js"
export * from "./DashMyTeam.vue?vue&type=script&lang=js"

import "./DashMyTeam.vue?vue&type=style&index=0&id=4b04fa45&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b04fa45"]])

export default __exports__